import { EdgeToEdge } from '@mindly/capacitor-android-edge-to-edge-support';
import { StatusBar, Style } from '@capacitor/status-bar';
import { isPlatform } from '@ionic/react';

const canSetStatusBarStyle = () => isPlatform('android');

const setStatusBarStyle = async (style?: Style) => {
  if (canSetStatusBarStyle()) {
    const statusBarInfo = await StatusBar.getInfo();
    const statusBarPromise = style && statusBarInfo.overlays ? StatusBar.setStyle({ style }) : Promise.resolve();
    return statusBarPromise;
  }
  return Promise.resolve();
};

export const setSplashColor = async (color: string, style: Style = Style.Light) => {
  document?.querySelector('meta[name="theme-color"]')?.setAttribute('content', color);
  try {
    if (canSetStatusBarStyle()) {
      const setBackgroundColorPromise = EdgeToEdge.setBackgroundColor({ color });
      const statusBarPromise = setStatusBarStyle(style);
      await Promise.all([setBackgroundColorPromise, statusBarPromise]);
    }
  } catch (error) {
    console.error(error);
  }
  return Promise.resolve();
};
